import React, { Component, Fragment } from 'react'
import Header from './partials/Header'
import Footer from './partials/Footer'
import { Col, Container, Row } from 'reactstrap'

export class DownloadApp_QRCode extends Component {
    componentDidMount() {
        window.setTimeout(()=>{this.props.history.push("/my-games")},5000)
    }
    render() {
        return (
            <Fragment>
                <Header {...this.props}/>
                <div className="bg-purple-1 text-white-1 py-5 margin-top-fix">

                    <div>
                        <h5 className="text-center">You finally got this event in your app <br />
                            Go now and play with your team
                        </h5>
                        <h3 className="text-center mt-5">Download App Now !</h3>
                    </div>

                    <Container>
                        <div className="download-content">
                            <Row className = "justify-content-center">
                                <Col lg = {6} md = {8} className = "order-2 order-lg-1">
                                    <Row>
                                        <Col lg={12} className = "mt-0 mt-lg-5">
                                            <p>
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                                Neque leo curabitur viverra felis. Vestibulum purus felis sed sagittis.
                                                Rutrum potenti urna, gravida congue id cras scelerisque ut.
                                                Nisi, eget fringilla eu odio volutpat habitant lectus.
                                            </p>
                                        </Col>
                                        <Col lg={12} className = "mt-2 mt-lg-5">
                                            <Row className = "justify-content-between">
                                                <Col lg={4} md = {6} sm = {6} xs = {8} className = "mt-4 mt-lg-5">
                                                    <div className="downloadApp-store downloadApp-store-1 "></div>
                                                    <div className="downloadApp-store downloadApp-store-2 mt-3 mt-lg-5"></div>
                                                </Col>
                                                <Col lg={6} md = {6} sm = {6} xs = {8}  className = "mt-3 mt-md-0">
                                                    <div className="qr-container">
                                                        <div className="downloadApp-qr"></div>
                                                        <p className="text-center mt-2">Scan QR Code</p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg = {6} md = {6}  className = "order-1 order-lg-2">
                                    <div className="downloadApp-main downloadApp-main-1"></div>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </div>
                <Footer />
            </Fragment>
        )
    }
}

export default DownloadApp_QRCode
